<template>
  <div class="nav-wp">
    <div class="slash" @click="toggleNav" :class="!isNav ? 'slash-show' : 'slash-hide'"></div>
    <div class="mask" v-show="isNav" @touchstart="hide"></div>
    <div class="nav-wp-inner" :class="isNav ? 'show' : 'hide'">
      <div class="person"></div>
      <div class="outer">
        <ul class="nav-ul">
          <li class="nav-item">
            <div class="round-outer">
              <div class="round" @click="goP1">
                <span class="icon icon1"></span>
                <span class="text">开篇</span>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="round-outer" :class="activeNum === 2 ? 'round-outer2' : ''">
              <div class="round" @click="goP2">
                <span class="icon icon2" :class="activeNum === 2 ? 'icon2a' : ''"></span>
                <span class="text">宣贯</span>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="round-outer" :class="activeNum === 3 ? 'round-outer3' : ''">
              <div class="round" @click="goP3">
                <span class="icon icon3" :class="activeNum === 3 ? 'icon3a' : ''"></span>
                <span class="text">传播</span>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="round-outer" :class="activeNum === 4 ? 'round-outer4' : ''">
              <div class="round" @click="goP4">
                <span class="icon icon4" :class="activeNum === 4 ? 'icon4a' : ''"></span>
                <span class="text">活动</span>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="round-outer" :class="activeNum === 5 ? 'round-outer5' : ''">
              <div class="round" @click="goP5">
                <span class="icon icon5" :class="activeNum === 5 ? 'icon5a' : ''"></span>
                <span class="text">转化</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
    activeNum: Number
  },
  data() {
    return {
      isNav: false
    }
  },
  methods: {
    toggleNav() {
      this.isNav = !this.isNav;
    },
    hide() {
      this.isNav = false;
    },
    goP1() {
      setTimeout(() => {
        this.isNav = false;
      }, 300)
      setTimeout(() => {
        this.$emit('nav', 'isPOShow');
      }, 700)

    },
    goP2() {
      setTimeout(() => {
        this.isNav = false;
      }, 300)
      setTimeout(() => {
        this.$emit('nav', 'isPTShow');
      }, 700);
    },
    goP3() {
      setTimeout(() => {
        this.isNav = false;
      }, 300)
      setTimeout(() => {
        this.$emit('nav', 'isPHShow');
      }, 700)

    },
    goP4() {
      setTimeout(() => {
        this.isNav = false;
      }, 300)
      setTimeout(() => {
        this.$emit('nav', 'isPFShow');
      }, 700)
    },
    goP5() {
      setTimeout(() => {
        this.isNav = false;
      }, 300)
      setTimeout(() => {
        this.$emit('nav', 'isPVShow');
      }, 700);
    },
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(@url);
}
.nav-wp {
  position: fixed;
  right: 0;
  top: .625rem /* 10/16 */;
  z-index: 10;
}
.slash {
  width: 2.1875rem /* 35/16 */;
  height: 2.1875rem /* 35/16 */;
  margin-left: 3rem;
  margin-bottom: .625rem /* 10/16 */;
  background-image: url('./img/nav.png');
  background-repeat: no-repeat;
  background-size: cover;
  transition: all .3s;
  &:active {
    opacity: .8;
  }
}
.slash-show {
  opacity: 1;
}
.slash-hide {
  opacity: 0;
}
.person {
  width: 66px;
  height: 67px;
  margin-left: 1rem;
  background-image: url('./img/person.png');
  background-repeat: no-repeat;
  animation: personAni 1s steps(6) infinite;
  transition: transform .6s .3s;
}
.outer {
  padding: 1.25rem /* 20/16 */ 0;
  background-color: white;
  border-radius: .375rem /* 6/16 */ 0 0 .625rem /* 10/16 */;
}
.nav-item {
  padding: .625rem /* 10/16 */ 1.25rem /* 20/16 */;
  &:active {
    background-color: rgba(20, 20, 20, .05);
  }
}
.nav-wp-inner {
  transition: all .3s;
  margin-top: -40px;
  z-index: 10;
}
.show {
  transform: translateX(0);
  .person {
    transform: translateX(0);
  }
}
.hide {
  transform: translateX(100%);
  .person {
    transform: translateX(100%);
  }
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
}
.round {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon {
  margin-bottom: .5rem /* 8/16 */;
}
.round-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.125rem /* 50/16 */;
  height: 3.125rem /* 50/16 */;
  border-radius: 50%;
}
.round-outer2 {
  background: linear-gradient(-45deg, #77d4ff 2%, #3f9fff 50%, #1272ff 99%);
  .text {
    color: white;
  }
}
.round-outer3 {
  background: linear-gradient(-45deg, #b2ec72 2%, #79ab57 50%, #497140 99%);
  .text {
    color: white;
  }
}
.round-outer4 {
  background: linear-gradient(-45deg, #ffd149 2%, #ffb926 50%, #ffa60b 99%);
  .text {
    color: white;
  }
}
.round-outer5 {
  background: linear-gradient(-45deg, #f08266 2%, #ee6354 50%, #eb4845 99%);
  .text {
    color: white;
  }
}
.icon1 {
  display: inline-block;
  width: 2/2rem /* 32/16 */;
  height: 2.25/2rem /* 36/16 */;
  .bg('./img/icon1.png');
}
.icon2 {
  display: inline-block;
  width: 3.5625/2rem /* 57/16 */;
  height: 2.5/2rem /* 40/16 */;
  .bg('./img/icon2.png');
}
.icon2a {
  .bg('./img/icon2-a.png');
}
.icon3 {
  display: inline-block;
  width: 2.875/2rem /* 46/16 */;
  height: 2.25/2rem /* 36/16 */;
  .bg('./img/icon3.png');
}
.icon3a {
  .bg('./img/icon3-a.png');
}
.icon4 {
  display: inline-block;
  width: 2.3125/2rem /* 37/16 */;
  height: 2.3125/2rem /* 37/16 */;
  .bg('./img/icon4.png');
}
.icon4a {
  .bg('./img/icon4-a.png');
}
.icon5 {
  display: inline-block;
  width: 2.375/2rem /* 38/16 */;
  height: 1.25rem /* 20/16 */;
  .bg('./img/icon5.png');
}
.icon5a {
  .bg('./img/icon5-a.png');
}
.text {
  font-size: .75rem /* 12/16 */;
  color: #2740be;
}
@keyframes personAni {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -396px;
  }
}
</style>
